export const version = "1.7.17-daily-20260820-0";
export const channel = "daily";
export const gitcommit = "1ea652c03";
